/**
 * Blog Hero view script (front-end).
 * Optional: smooth scroll to next section when "Scroll for more" is clicked.
 */
document.addEventListener( 'DOMContentLoaded', function () {
	const hint = document.querySelector( '[data-scroll-hint]' );
	if ( ! hint ) return;
	hint.addEventListener( 'click', function () {
		const hero = document.getElementById( 'tsw-blog-hero' );
		if ( hero && hero.nextElementSibling ) {
			hero.nextElementSibling.scrollIntoView( { behavior: 'smooth' } );
		}
	} );
} );
